import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainNavbar from "./components/Navbar";

import HomePage from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import ProductDetails from "./pages/Fungicides";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/Footer";
import CategoryProducts from "./pages/CategoryProducts";



function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <MainNavbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/product/:slug" element={<ProductDetails />} />
        <Route path="/category/:categorySlug" element={<CategoryProducts />} />

      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
